import { format } from "date-fns";

import { ContextStateAction, ContextStateProps } from "./types";


export const initialState: ContextStateProps = {
  start_date: format(new Date().setDate(new Date().getDate() - 59), "yyyy-MM-dd"),
  end_date: format(new Date().setDate(new Date().getDate() + 1), "yyyy-MM-dd"),
  period: "day",
  filter_type: "",
  type: "index",
  role: "",
  soc_value: "",
  drug_id: "",
  id: "",
  insurance_name: null,
}

export const queryDispatcher = (state: ContextStateProps, action: ContextStateAction): ContextStateProps => {
  if (action.type === "UPDATE_STATE") {
    return {
      ...state,
      ...action.payload,
    }
  } else {
    return state;
  }
}
